import React from "react";

const TailwinButton = ({ onClick, value, disabled }) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`px-4 py-2 rounded text-white font-semibold transition duration-200 
        ${disabled ? "bg-gray-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"}
      `}
    >
      {value}
    </button>
  );
};

export default TailwinButton;
